import React, { Component } from "react";
import { Card, Row, Col, Button, Form, Input } from "antd";
import "./searchMember.css";

export default class cliamsHistory extends Component {
  render() {
    return (
      <div className="p-2 pb-3">
        <Row className="p-2 member-info-header">
          <Col className="pr-1" span={3}>Claim No. </Col>
          <Col className="pr-1" span={3}>
            NPI{" "}
          </Col>
          <Col className="pr-1" span={2}>State </Col>
          <Col className="pr-1" span={4}>Billing Provider </Col>
          <Col className="pr-1" span={2} className="">
            D.O.S. From{" "}
          </Col>
          <Col className="pr-1" span={2}>
            D.O.S. To{" "}
          </Col>
          <Col className="pr-1" span={2}>Received Date </Col>
          <Col className="pr-1" span={2}>Tot. Charges </Col>
          <Col className="pr-1" span={2}>Net Pay Amt. </Col>
          <Col className="pr-1" span={2}>
            Date Paid{" "}
          </Col>
        </Row>
        <hr></hr>
        {/* Calling the Api and binding the data */}

        {this.props.claimsdata.map((item) => {
          return (
            <Row className="p-2 row-details">
              <Col className="pr-1" span={3}>{item.claimNumber} </Col>
              <Col className="pr-1" span={3}>
                {item.pcpNPI}
              </Col>
              <Col className="pr-1" span={2}>{item.claimStatus} </Col>
              <Col className="pr-1" span={4}>
                {item.billingProviderName}
              </Col>
              <Col className="pr-1" span={2}>
                {item.dosFromDate}
              </Col>
              <Col className="pr-1" span={2}>
                {item.dosToDate}
              </Col>
              <Col className="pr-1" span={2}>
                {item.planReceivedDate}
              </Col>
              <Col className="pr-1" span={2}>
                {item.totalPaymentAmount ? "$" + parseFloat(item.totalPaymentAmount).toFixed(2) : "$0.00"}
              </Col>
              <Col className="pr-1" span={2}>
                {item.totalNetPaymentAmt ? "$" + parseFloat(item.totalNetPaymentAmt).toFixed(2) : "$0.00"}
              </Col>
              <Col className="pr-1" span={2}>
                {item.paidOn}
              </Col>
            </Row>
          );
        })}
      </div>
    );
  }
}
